/**
 * Quiseya · Galería de la ficha: lupa al pasar el ratón (escritorio, puntero fino).
 *
 * Añade un recuadro sobre la foto y un panel flotante con la zona ampliada (2.6×).
 * Es defensivo: sin galería o con puntero táctil no hace nada.
 * El fondo de marca y el producto integrado (blend) son solo CSS (assets/quiseya.css).
 */
(function () {
  'use strict';

  var ZOOM = 2.6;

  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (!window.matchMedia('(min-width: 750px)').matches) return;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var gal = document.querySelector('.product-information media-gallery') || document.querySelector('media-gallery');
    if (!gal) return;

    var host = gal.closest('.product-information__media') || gal.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var pane = document.createElement('div');
    pane.className = 'qy-lup';
    pane.setAttribute('aria-hidden', 'true');

    var lens = document.createElement('div');
    lens.className = 'qy-lens';

    host.appendChild(pane);

    function bind(c) {
      var img = c.querySelector('img.product-media__image');
      if (!img) return;

      c.addEventListener('mouseenter', function () {
        c.appendChild(lens);
        var r = c.getBoundingClientRect();
        var hr = host.getBoundingClientRect();
        var avail = window.innerWidth - r.right - 40;
        var w = Math.min(r.width, Math.max(avail, 280));
        pane.style.left = Math.round(r.right - hr.left + 16) + 'px';
        pane.style.top = Math.round(r.top - hr.top) + 'px';
        pane.style.width = Math.round(w) + 'px';
        pane.style.height = Math.round(w * r.height / r.width) + 'px';
        pane.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
        pane.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
        pane.classList.add('on');
        lens.style.display = 'block';
      });

      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect();
        var lw = r.width / ZOOM, lh = r.height / ZOOM;
        var x = Math.min(Math.max(e.clientX - r.left - lw / 2, 0), r.width - lw);
        var y = Math.min(Math.max(e.clientY - r.top - lh / 2, 0), r.height - lh);
        lens.style.width = lw + 'px';
        lens.style.height = lh + 'px';
        lens.style.left = x + 'px';
        lens.style.top = y + 'px';
        pane.style.backgroundPosition = (-x * ZOOM) + 'px ' + (-y * ZOOM) + 'px';
      });

      c.addEventListener('mouseleave', function () {
        pane.classList.remove('on');
        lens.style.display = 'none';
      });
    }

    Array.prototype.forEach.call(gal.querySelectorAll('.product-media-container'), bind);
  });
})();
